import { Button, Col, Row } from 'antd';
import React from 'react';
import ByMuvu from '../../PatientLandingGeneralComponents/ByMuvu';

const BeforeFinish = ({ summaryHandler }) => {
  return (
    <Row className='patient-landing-container mt-180 mr-20 ml-20' justify='center'>
      <Col span={24}>
        <h2 className="mb-0 text-center">{summaryHandler.examName || 'Encuesta de Salud'}</h2>
      </Col>
      <Col span={24} className='mt-120'>
        <h3 className="mb-0 text-center text-orange pl-80 pr-80">¡Ya, estás por terminar tu {summaryHandler.examName || 'Encuesta de Salud'}!</h3>
      </Col>
      <Col span={24} className='mt-30'>
        <h3 className='mb-0 text-center pl-80 pr-80'>Por favor, revisa tus respuestas antes de finalizar este paso</h3>
      </Col>
      <Col span={24}>
        <Row className='text-center mt-120' justify='center'>
          <Col span={24} sm={14} md={14} lg={14}>
            <div>
              <Button
                className="cmt-button primary"
                type="primary"
                size='large'
                block
                style={{ width: '95%' }}
                onClick={() => summaryHandler.setIsSummaryStarted(true)}
              >
                Revisar respuestas
              </Button>
            </div>
          </Col>
        </Row>
      </Col>
      <Col span={24} className='mt-30'>
        <ByMuvu />
      </Col>
    </Row>
  )
}

export default BeforeFinish;
